import persistenceOfMemoryPNG from '~/assets/images/art/persistence-of-memory.png'
import persistenceOfMemoryWEBP from '~/assets/images/art/persistence-of-memory.webp'
import { ImageChoiceQuiz } from '~/shared/components/ImageChoiceQuiz'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTIONS = [
  { key: 'impressionism', i18nKey: 'impressionism' },
  { key: 'surrealism', i18nKey: 'surrealism' },
  { key: 'realism', i18nKey: 'realism' },
  { key: 'notSure', i18nKey: 'notSure' },
] as const

const PersistenceOfMemory = (props: TPageProps) => (
  <ImageChoiceQuiz
    {...props}
    ns="art"
    question="Which style is this?"
    questionI18nKey="onboarding.artQuiz.persistenceOfMemory.question"
    optionsI18nKeyPrefix="onboarding.artQuiz.persistenceOfMemory.options"
    options={OPTIONS}
    image={{
      png: persistenceOfMemoryPNG,
      webp: persistenceOfMemoryWEBP,
      alt: 'The Persistence of Memory',
    }}
  />
)

export default PersistenceOfMemory
